var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('van-loading',{staticClass:"loading",style:({ height: _vm.height, width: '100%' }),attrs:{"type":"spinner","color":"#B3B5B9"}},[_vm._v(" 加载中... ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }